import { cloneDeep } from 'lodash';
const SET_FEATURED = 'SET_FEATURED';

const initialState = [];

export default function reducer(state = cloneDeep(initialState), action) {
	switch (action.type) {
		case SET_FEATURED:
			return action.payload;
		default:
			return state;
	}
}

export function setFeatured( featured=[] ){
	return{
		type: SET_FEATURED,
		payload: featured
	}
}



// WEBPACK FOOTER //
// ./src/modules/featured.js